<template>
	<div class="hub-hero-featured">
		<nav>
			<button
				v-for="(tab, idx) in tabs"
				:key="tab.value"
				type="button"
				:class="['btn', 'btn-' + tab.value, current_tab_slug === tab.value ? 'current' : '']"
				@click="set_tab(tab.value)"
			>
				{{ tab.label }}

				<template v-if="idx === 0">
					<span v-for="n in tabs.length - 1" :key="n" />
				</template>

				<span v-else />
			</button>
		</nav>

		<p v-if="current_tab && current_tab.text">
			{{ current_tab.text }}
		</p>

		<div class="links">
			<a
				v-for="item in truncated_items"
				:key="item.id"
				:href="item.url"
				:class="['btn', 'btn-solid', item.color]"
				:title="item.label"
			>
				<span>{{ item.label }}</span>
			</a>
		</div>

		<footer v-if="filtered_items.length > 6">
			<button type="button" class="btn btn-link small" @click="toggle_show_all">
				{{ !show_all ? 'View more' : 'Collapse' }}
			</button>
		</footer>
	</div>
</template>

<script setup>
import { computed, onMounted, ref } from 'vue';

const props = defineProps({
	tabs: {
		type: Array,
		required: true,
	},
	items: {
		type: Array,
		required: true,
	},
	url: {
		type: String,
		required: true,
	},
});

const current_tab_slug = ref(props.tabs[0].value);

const current_tab = computed(() => {
	for (const tab of props.tabs) {
		if (tab.value !== current_tab_slug.value) {
			continue;
		}

		return tab;
	}

	return null;
});

const show_all = ref(false);

const filtered_items = computed(() => {
	if (current_tab_slug.value === props.tabs[0].value) {
		return props.items;
	}

	return props.items.filter((item) => item.type === current_tab_slug.value);
});

const truncated_items = computed(() => {
	if (!show_all.value) {
		return filtered_items.value.slice(0, 6);
	}

	return filtered_items.value;
});

function set_tab(slug) {
	current_tab_slug.value = slug;

	if (slug === `all`) {
		window.history.pushState({}, ``, window.location.pathname);
	} else {
		window.history.pushState({}, ``, `#${slug}`);
	}
}

function toggle_show_all() {
	show_all.value = !show_all.value;
}

onMounted(() => {
	switch (window.location.hash) {
		case `#popular`:
			current_tab_slug.value = `popular`;
			break;
		case `#best`:
			current_tab_slug.value = `best`;
			break;
	}
});
</script>
